const { sameParagraphStyleInTextBodies } = require('../utils');

exports.computeSpacingsFromTextBodies = (textBodies, textSelection) => ({
    bottom: sameParagraphStyleInTextBodies(textBodies, 'padding.bottom', undefined, { textSelection }),
    left: sameParagraphStyleInTextBodies(textBodies, 'padding.left', undefined, { textSelection }),
    right: sameParagraphStyleInTextBodies(textBodies, 'padding.right', undefined, { textSelection }),
    top: sameParagraphStyleInTextBodies(textBodies, 'padding.top', undefined, { textSelection })
});
